/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * TypeScript/React version of TextLinkButton
 * Based on the original JSX version in /lego/component/TextLinkButton.jsx
 */

import React from 'react'
import { Button } from 'react-bootstrap'

interface TextLinkButtonProps {
  action?: () => void
  title?: string
  children?: React.ReactNode
  className?: string
  disabled?: boolean
  onClick?: () => void // Alternative to action for modern React patterns
  style?: React.CSSProperties // Support inline styles
}

/**
 * TextLinkButton component renders a link-styled button using React Bootstrap
 *
 * Converted from legacy component to use modern React Bootstrap v2+ patterns
 * - Uses 'variant="link"' instead of 'bsStyle="link"'
 * - Supports both 'action' (legacy) and 'onClick' (modern) props
 * - Added TypeScript interfaces for type safety
 */
const TextLinkButton: React.FC<TextLinkButtonProps> = ({
  action,
  onClick,
  title,
  children,
  className = '',
  disabled = false,
  style
}) => {
  const handleClick = () => {
    // Support both legacy 'action' prop and modern 'onClick' prop
    const clickHandler = onClick || action
    if (typeof clickHandler === 'function') {
      clickHandler()
    }
  }

  return (
    <Button
      className={`text-link-btn ${className}`}
      variant="link"
      title={title}
      disabled={disabled}
      onClick={handleClick}
      style={style}
    >
      {children}
    </Button>
  )
}

export default TextLinkButton
